module.exports = __webpack_public_path__ + "static/media/iPhone14_2.21e903b0.png";